__turbopack_context__.v({
  "breadcrumb": "Footer-module-sass-module__D2nguG__breadcrumb",
  "divider": "Footer-module-sass-module__D2nguG__divider",
  "dividerHorizontal": "Footer-module-sass-module__D2nguG__dividerHorizontal",
  "dividerVertical": "Footer-module-sass-module__D2nguG__dividerVertical",
  "footer": "Footer-module-sass-module__D2nguG__footer",
  "key": "Footer-module-sass-module__D2nguG__key",
  "options": "Footer-module-sass-module__D2nguG__options",
  "optionsLabel": "Footer-module-sass-module__D2nguG__optionsLabel",
  "rotation": "Footer-module-sass-module__D2nguG__rotation",
  "spinner": "Footer-module-sass-module__D2nguG__spinner",
  "themeDependent": "Footer-module-sass-module__D2nguG__themeDependent",
  "themeDependentAndBright": "Footer-module-sass-module__D2nguG__themeDependentAndBright",
});
